const STORAGE_LOCALE_KEY = "FlowLocale"

export default { STORAGE_LOCALE_KEY }
